import { UPDATE_AUTH, EMPTY_AUTH } from "../../store/actionTypes";

const initial = {
  isLoading: false,
  adminDetails: {
    profileImage: "",
  },
};

/**
 *
 * @param {initial state of reducer} state
 * @param { perfoam actions } action
 * @returns update state of reducer
 */

const AuthReducer = (state = initial, action) => {
  switch (action.type) {
    case UPDATE_AUTH:
      return { ...state, ...action.payload };
    case EMPTY_AUTH:
      return initial;
    default:
      return state;
  }
};

export default AuthReducer;
